export const KEY_DESK_VISIBLE = 'intercomHelpDeskVisible'
export const INTERCOM_BODY_CLASS_NAME = 'intercom-hidden'
export const sendIntercomMessage = (message) => {
  if (window.Intercom) {
    showIntercomHelpDesk()

    window.Intercom('hide');
    window.Intercom('show');
    window.Intercom('showNewMessage', message);
  }
}

export const toggleIntercomHelpDesk = () => {
  const intercomHelpDeskVisible = localStorage.getItem(KEY_DESK_VISIBLE) !== '0'
  localStorage.setItem(KEY_DESK_VISIBLE, intercomHelpDeskVisible ? '0' : '1')
  if(intercomHelpDeskVisible){
    document.body.classList.add(INTERCOM_BODY_CLASS_NAME)
  }else{
    document.body.classList.remove(INTERCOM_BODY_CLASS_NAME)
  }
}

export const showIntercomHelpDesk = () => {
  localStorage.setItem(KEY_DESK_VISIBLE, '1')
  document.body.classList.remove(INTERCOM_BODY_CLASS_NAME)
}

export const isIntercomHelpDeskVisible = () => {
  return localStorage.getItem(KEY_DESK_VISIBLE) !== '0'
}